module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/am165-ea392f77738ecb0a089cbb02b69bed6d.jpg";